module.exports = __webpack_public_path__ + "static/media/ichapter-logo.6ee8dd3a.gif";